import { render, staticRenderFns } from "./settings-organization-integrations.vue?vue&type=template&id=d2b62248&scoped=true&"
import script from "./settings-organization-integrations.vue?vue&type=script&lang=js&"
export * from "./settings-organization-integrations.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization-integrations.vue?vue&type=style&index=0&id=d2b62248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b62248",
  null
  
)

export default component.exports